import { ICardElementWithChildren } from "backend/model/model";
import PercentageBar from "design/components/progress/PercentageBar";
import { changeColorBrightness } from "qpr-base/utils/color";
import React from "react";
import DomElement from "reportengine/DomElement";
import Portion from "reportengine/Portion";
import Slide from "reportengine/Slide";
import SlideTable from "reportengine/SlideTable";
import SlideTableRow from "reportengine/SlideTableRow";
import Text from "reportengine/Text";
import TextElement from "reportengine/TextElement";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import { t } from "i18next";
import { getTranslatedAttribute } from "qpr-base//tplutils/utils";
import * as conf from "qpr-base/configuration";
import {TCellType} from "qpr-base/configuration/types";

const InitiativePerformanceTable = (
  props: React.PropsWithChildren<{
    items: ICardElementWithChildren[];
    report: ICardElementWithChildren;
    title?: string;
    translatedScorecardName?: string;
  }>
) => {
  const { items } = props;
  const ctx = useAppContext();
  const tableSeries = conf.getInitiativePerformanceTableSettings(items[0]);
  //   const lastPeriod = useYearsLastPeriod(item.period?.name || "");
  const getTableRow = (
    value: ICardElementWithChildren,
	  series: string,
    cellType: TCellType | undefined,
    colorAttribute: string | undefined
  ) => {
    if (!cellType) {
      return (
        <TextElement slideElement="">
          {value[`${series}_prettyvalue` as keyof ICardElementWithChildren]}
        </TextElement>
      );
	  } else if (cellType === "showRangeColor") {
      const darker = changeColorBrightness(`#${value[`${colorAttribute}` as keyof ICardElementWithChildren]}`, 0.72);
      return (
          <DomElement slideElement="" typename="image" selector=".item">
          {value[`${series}` as keyof ICardElementWithChildren] ? (
            <div
              className="item"
              style={{
                width: "120px",
                padding: "10px",
                background: `linear-gradient(#${value[`${colorAttribute}` as keyof ICardElementWithChildren]}22, 
                              #${value[`${colorAttribute}` as keyof ICardElementWithChildren]}55)`,
                borderRadius: "20px",
                fontSize: "18px",
                color: darker,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {value[`${series}_prettyvalue` as keyof ICardElementWithChildren]}
            </div>
          ) : (
            <div className="item">0%</div>
          )}
        </DomElement>
      );
    }    
    else {
      return (
        <DomElement slideElement="" typename="image" selector=".item">
          <div
            className="item"
            style={{ width: "120px", height: "40px" }}
          >
            <PercentageBar
              color={`#${value[`${colorAttribute}` as keyof ICardElementWithChildren]}`}
              value={Number(value[`${series}` as keyof ICardElementWithChildren])}
            />
          </div>
        </DomElement>
	    );	
    }
  }

  return (
    <>
      <Slide index={8}>
        <TextElement slideElement="title">
          {props.title || t("strategyReport.Initiative Performance Summary")}          
        </TextElement>
        <TextElement slideElement="period">
          {props.report.period?.name || ""}
        </TextElement>
        <TextElement slideElement="footer">
          {props.translatedScorecardName || t("strategyReport.Performance Report")}
        </TextElement>
        <Text slideElement="total_cnt">
          <Portion paragraphIndex={0} portionIndex={0}>
            {items.length}&nbsp;
          </Portion>
          <Portion paragraphIndex={0} portionIndex={1}>
            {t("strategyReport.TOTAL")}
          </Portion>
        </Text>
        <TextElement slideElement="initiative_table_headerrow_name" >
           {t("strategyReport.NAME")}
        </TextElement>
        {tableSeries.series?.map((ser, index) => {
          return (
            <TextElement slideElement={"initiative_table_headerrow" + index} >
              {t("strategyReport.InitiativeTableCol" + index)}
            </TextElement>
           );
        })}

        <SlideTable slideElement="initiative_performance_table">
          {items.map((item) => {
            const darker = changeColorBrightness(`#${item.rangecolor}`, 0.72);

            return (
              <SlideTableRow>
                <TextElement slideElement="">{getTranslatedAttribute(item, "Name", ctx.language)}</TextElement>
                {tableSeries.series?.map((ser, index) => {
                  return (
                    getTableRow(item, ser.symbol, ser.cellType, ser.colorAttribute)
                  );
                })}
              </SlideTableRow>
            );
          })}
        </SlideTable>
      </Slide>
    </>
  );
};

export default InitiativePerformanceTable;
